export const getOpenApiSpecTitle = (spec?: string): string | undefined => {
  if (!spec) {
    return undefined;
  }

  const match = new RegExp(String.raw`title:\s*(.*?)(?:\n|$)`).exec(spec);

  return match?.[1];
};
